<template>
  <Wrapper pageIcon="billing">
    <form v-on:submit.prevent="save">
      <FieldWrapper>
        <input
          :value="user.first_name"
          v-validate="validatorDefinitions.first_name"
          @input="update"
          name="first_name"
          placeholder="First Name"
          data-vv-scope="shipping"
        />
        <div slot="errors" v-if="errors.has('first_name', 'shipping')">
          {{ errors.first("first_name", "shipping") }}
        </div>
      </FieldWrapper>
      <FieldWrapper>
        <input
          :value="user.last_name"
          v-validate="validatorDefinitions.last_name"
          @input="update"
          name="last_name"
          placeholder="Last Name"
          data-vv-scope="shipping"
        />
        <div slot="errors" v-if="errors.has('last_name', 'shipping')">
          {{ errors.first("last_name", "shipping") }}
        </div>
      </FieldWrapper>
      <FieldWrapper v-if="countries">
        <select
          name="country_code"
          @input="update"
          v-validate="validatorDefinitions.country_code"
          data-vv-scope="shipping"
        >
          <option
            v-for="country in countries"
            :selected="user.country_code === country.code_2"
            :value="country.code_2"
            >{{ country.name }}
          </option>
        </select>
        <Icon slot="icon" class="field-icon" type="down" />
        <div slot="errors" v-if="errors.has('country_code', 'shipping')">
          {{ errors.first("country_code", "shipping") }}
        </div>
      </FieldWrapper>
      <FieldWrapper v-if="states">
        <select
          name="state_code"
          @input="update"
          v-validate="validatorDefinitions.state_code"
          data-vv-scope="shipping"
        >
          <option value="">Select State / Region</option>
          <option
            v-for="state in states"
            :selected="user.state_code === state.code_2"
            :value="state.code_2"
            >{{ state.name }}
          </option>
        </select>
        <Icon slot="icon" class="field-icon" type="down" />
        <div slot="errors" v-if="errors.has('state_code', 'shipping')">
          {{ errors.first("state_code", "shipping") }}
        </div>
      </FieldWrapper>
      <FieldWrapper>
        <input
          :value="user.city"
          @input="update"
          name="city"
          v-validate="validatorDefinitions.city"
          placeholder="City"
          data-vv-scope="shipping"
        />
        <div slot="errors" v-if="errors.has('city', 'shipping')">
          {{ errors.first("city", "shipping") }}
        </div>
      </FieldWrapper>
      <FieldWrapper>
        <input
          :value="user.address"
          @input="update"
          name="address"
          v-validate="validatorDefinitions.address"
          placeholder="Address"
          data-vv-scope="shipping"
        />
        <div slot="errors" v-if="errors.has('address', 'shipping')">
          {{ errors.first("address", "shipping") }}
        </div>
      </FieldWrapper>
      <FieldWrapper>
        <input
          :value="user.zip"
          @input="update"
          name="zip"
          v-validate="validatorDefinitions.zip"
          placeholder="Zip Code"
          data-vv-scope="shipping"
        />
        <div slot="errors" v-if="errors.has('zip', 'shipping')">
          {{ errors.first("zip", "shipping") }}
        </div>
      </FieldWrapper>
      <DecoratedButton type="submit" name="save" :loading="loading">
        UPDATE SHIPPING INFORMATION
      </DecoratedButton>
    </form>
  </Wrapper>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import Wrapper from "@/components/partials/profile/Wrapper";

export default {
  name: "form-profile-shipping",
  components: { Wrapper },
  computed: {
    ...mapGetters("user", {
      user: "getUser",
      loading: "getLoading"
    }),
    ...mapGetters("config", {
      countries: "getCountries"
    }),
    states: function() {
      if (this.countries && this.user.country_code) {
        let country = this.countries[this.user.country_code];

        if (
          country &&
          country.states &&
          Object.keys(country.states).length > 0
        ) {
          return country.states;
        }
      }

      return null;
    },
    isFormDirty() {
      return Object.keys(this.fields.$shipping).some(
        key => this.fields.$shipping[key].dirty
      );
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.isFormDirty) {
      if (
        confirm(
          "You have some unsaved changes, are you sure you want to continue?"
        ) == true
      ) {
        next();
      }
    } else {
      next();
    }
  },
  methods: {
    ...mapActions("user", {
      saveUserAttribute: "saveUserAttribute",
      updateUserAttribute: "updateUserAttribute"
    }),
    ...mapActions("config", {
      getCountriesData: "getCountriesData"
    }),
    resetForm() {
      Object.keys(this.fields.$shipping).some(
        key => (this.fields.$shipping[key].dirty = false)
      );
      setTimeout(() => {
        this.$validator.resume();
      }, 400);
    },
    save() {
      this.$validator.validateAll("shipping").then(valid => {
        if (valid) {
          this.$validator.pause();
          this.saveUserAttribute({
            first_name: this.user.first_name,
            last_name: this.user.last_name,
            country_code: this.user.country_code,
            state_code: this.user.state_code,
            address: this.user.address,
            city: this.user.city,
            zip: this.user.zip
          });
          this.resetForm();
        }
      });
    },
    update(e) {
      this.updateUserAttribute({
        attribute: e.target.name,
        value: e.target.value
      });
    }
  },
  created: function() {
    if (!this.countries || Object.keys(this.countries).length === 0) {
      this.getCountriesData();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrapper {
  min-width: 400px;
}
</style>
